export default "__VITE_ASSET__C8xh2_s6__"